export default function dateDiff(a, b) {
  return a.getTime() - b;
}